/* Cenit · Luz — interruptor, tonos, comparador y apariciones al hacer scroll */
(function () {
  var root = document.documentElement;
  root.classList.add('js-lz');

  function remember() {
    try { sessionStorage.setItem('cenit-luz', 'on'); } catch (e) {}
  }

  /* Pequeño "clic" de interruptor generado en el navegador (sin archivos de audio). */
  function click() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      var ctx = new Ctx();
      var o = ctx.createOscillator();
      var g = ctx.createGain();
      o.type = 'square';
      o.frequency.setValueAtTime(1800, ctx.currentTime);
      o.frequency.exponentialRampToValueAtTime(600, ctx.currentTime + 0.03);
      g.gain.setValueAtTime(0.08, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.05);
      o.connect(g); g.connect(ctx.destination);
      o.start(); o.stop(ctx.currentTime + 0.06);
      setTimeout(function () { ctx.close && ctx.close(); }, 200);
    } catch (e) {}
  }

  function setOn(on, withSound) {
    root.classList.toggle('cn-off', !on);
    document.querySelectorAll('[data-lz-toggle]').forEach(function (b) {
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (on) remember();
    if (withSound) click();
  }

  function initSwitch() {
    var hero = document.querySelector('[data-lz-switch]');
    if (!hero) { root.classList.remove('cn-off'); return; }

    document.querySelectorAll('[data-lz-toggle]').forEach(function (b) {
      b.setAttribute('aria-checked', root.classList.contains('cn-off') ? 'false' : 'true');
      b.addEventListener('click', function () {
        setOn(root.classList.contains('cn-off'), true);
      });
    });

    /* Si alguien baja sin pulsar, encendemos para no esconderle nada.
       Horizon desplaza la página dentro de .page-wrapper, no en window: escuchamos ambos. */
    var wrapper = document.querySelector('.page-wrapper');
    function onScroll() {
      var y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      if (y > 120 && root.classList.contains('cn-off')) {
        setOn(true, false);
        document.removeEventListener('scroll', onScroll, true);
      }
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    /* Accesibilidad: nadie se queda a oscuras. Se enciende sola si se navega con teclado
       (el foco sale de la portada) o si pasan unos segundos sin tocar nada. */
    document.addEventListener('focusin', function (e) {
      if (root.classList.contains('cn-off') && !hero.contains(e.target)) setOn(true, false);
    });
    setTimeout(function () {
      if (root.classList.contains('cn-off')) setOn(true, false);
    }, 6000);

    hero.addEventListener('click', function (e) {
      var t = e.target.closest('.lz-tone');
      if (!t) return;
      hero.setAttribute('data-tone', t.dataset.tone);
      hero.querySelectorAll('.lz-tone').forEach(function (x) {
        x.setAttribute('aria-pressed', x === t ? 'true' : 'false');
      });
    });
  }

  function initCompare() {
    document.querySelectorAll('[data-lz-compare]').forEach(function (box) {
      var range = box.querySelector('.lz-compare__range');
      if (!range) return;
      var update = function () { box.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', update);
      update();
    });
  }

  function initReveal() {
    var items = document.querySelectorAll('.lz-reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Fecha estimada de llegada: hoy + días laborables (sin sábados ni domingos). */
  function initEta() {
    var el = document.querySelector('[data-lz-eta]');
    if (!el) return;
    try {
      var addBiz = function (n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      };
      var a = addBiz(parseInt(el.dataset.min, 10) || 7);
      var b = addBiz(parseInt(el.dataset.max, 10) || 12);
      var fmt = new Intl.DateTimeFormat(el.dataset.locale === 'en' ? 'en-GB' : 'es-ES', { day: 'numeric', month: 'long' });
      var text = a.getMonth() === b.getMonth() ? a.getDate() + '–' + fmt.format(b) : fmt.format(a) + ' – ' + fmt.format(b);
      el.querySelector('[data-lz-eta-range]').textContent = text;
      el.hidden = false;
    } catch (e) {}
  }

  /* Lleva el aviso de stock de la ficha justo encima de los botones de compra. */
  function initStockNotice() {
    var notice = document.querySelector('[data-lz-aviso]');
    var buy = document.querySelector('.buy-buttons-block');
    if (!notice || !buy || !notice.children.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'lz-aviso';
    while (notice.firstChild) wrap.appendChild(notice.firstChild);
    buy.parentNode.insertBefore(wrap, buy);
    notice.setAttribute('data-moved', '');
  }

  function init() { initSwitch(); initCompare(); initReveal(); initEta(); initStockNotice(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
